import { Contract, ContractInterface } from '@ethersproject/contracts';
import { JsonRpcSigner, Web3Provider } from '@ethersproject/providers';

function contract<T>(
  address: string,
  abi: ContractInterface,
  provider: Web3Provider|JsonRpcSigner
): T {
  //@ts-ignore
  return new Contract(address, abi, provider) as T;
}

export default contract;
